import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import { CacheProvider } from '@emotion/react';
import createEmotionCache from './utils/createEmotionCache';
import theme from './styles/theme';
import { SessionContextProvider } from './contexts/SessionContext';
import App from './pages/App';
import { WebSocketProvider } from './contexts/WebSocketContext';
var clientCache = createEmotionCache();
var container = document.getElementById('root');
if (!container)
    throw new Error('Failed to find the root element');
var root = createRoot(container);
root.render(_jsx(CacheProvider, { value: clientCache, children: _jsxs(ThemeProvider, { theme: theme, children: [_jsx(CssBaseline, {}), _jsx(SessionContextProvider, { children: _jsx(WebSocketProvider, { autoConnect: false, children: _jsx(BrowserRouter, { children: _jsx(App, {}) }) }) })] }) }));
